let eventTracker = {};

(async () => {
    if (!document.location.href.includes('/a/loop_subscriptions')) return;

    window.addEventListener('load', () => {
        const ajs_user_id = JSON.parse(localStorage.getItem('ajs_user_id'));
        const ajs_user_traits = JSON.parse(localStorage.getItem('ajs_user_traits'));
        const loopUser = window?.loopProps?.customer;

        // Check if any trait values are empty
        const hasEmptyTraits = !ajs_user_traits?.email ||
            !ajs_user_traits?.firstName ||
            !ajs_user_traits?.lastName;

        if (!loopUser?.shopifyId || loopUser.shopifyId === Number(ajs_user_id) && !hasEmptyTraits) return;
        // speed4 iter04: Segment removed from theme. Guard the identify call so
        // the Loop subscription portal page doesn't throw if window.analytics
        // is undefined (which it now is on every page that doesn't otherwise
        // load Segment). Behavior unchanged when Segment is loaded.
        if (window.analytics && typeof window.analytics.identify === 'function') {
            window.analytics.identify(loopUser.shopifyId, {
                email: loopUser.email || ajs_user_traits.email,
                firstName: loopUser.first_name || ajs_user_traits.firstName,
                lastName: loopUser.last_name || ajs_user_traits.lastName
            });
        }
    });
})();

// DRAWER STATE

const getDrawerData = () => {
    const storedData = localStorage.getItem(DRAWER_DATA_KEY);
    return storedData ? JSON.parse(storedData) : null;
};

const setDrawerData = (newData) => {
    const currentData = getDrawerData() || {}; // Ensure existing data is considered
    const updatedData = { ...currentData, ...newData }; // Merge new values
    localStorage.setItem(DRAWER_DATA_KEY, JSON.stringify(updatedData));
};

const resetDrawerData = () => {
    localStorage.removeItem(DRAWER_DATA_KEY);
};

const DRAWER_DATA_KEY = 'loopDrawerData';

function initDrawerData() {
    const drawerContent = document.querySelector('.loop-drawer-content .loop-drawer-body');
    if (!drawerContent) return;

    // Get existing data
    const existingData = getDrawerData();

    const purchaseOption =
        drawerContent?.querySelector('input[type="radio"].loop-form-choice-input:checked')?.value || '';
    const packSize = drawerContent?.querySelector('.loop-form-container select')?.value || '';

    const newData = {
        ...existingData, // Preserve existing properties (like isRecommended)
        hideCancelReasonInput: false,
        cancelReason: '',
        content: {
            title: drawerContent?.querySelector('.loop-h2')?.textContent?.trim() || '',
            price: drawerContent?.querySelector('.loop-text-p1')?.textContent?.trim()?.split('$')[1] || '',
            ...(purchaseOption &&
                purchaseOption !== 'onetime' && {
                oldPrice:
                    drawerContent?.querySelector('.text-decoration-line-through')?.textContent?.trim()?.split('$')[1] || '',
            }),
            selectedSize: drawerContent?.querySelector('.loop-form-container select')?.value || '',
            ...(packSize && { packSize }),
            quantity: drawerContent?.querySelector("input[type='number']")?.value || '',
            ...(purchaseOption && { purchaseOption }),
        },
    };
    localStorage.setItem(DRAWER_DATA_KEY, JSON.stringify(newData));
}

const drawerStateObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.addedNodes.length) {
            const drawer = document.querySelector('.loop-drawer-content .loop-drawer-body');
            if (drawer) {
                initDrawerData();
                break;
            }
        }
    }
});

drawerStateObserver.observe(document.body, { childList: true, subtree: true });

// DRAWER STATE END

//DRAWERS
const RESCHEDULE_ORDER = 'Reschedule order';
const PAUSE_SUBSCRIPTION = 'Pause subscription';
const DELAY_SUBSCRITON = 'Delay Subscription';
const CADENCE_CHANGE = 'Edit cadence';
const CANCEL_SUBSCRIPTION = 'Before you cancel';
const ONE_TIME = 'One-time purchase';
const PRODUCT_RECOMMENDATION_ADDON = 'Product Recommendation Add-on';
const LOOP_LOYALTY = 'Loyalty points/Coupons';
const LOOP_REDEEM_POINTS = 'Loop Redeem Points';
const GET_COUPON_CODE = 'Get coupon code';

// MODALS
const IMMEDIATE_ORDER = 'Place an Immediate Order';
const ORDER_NOW = 'Order now';
const SKIP_ORDER = 'Skip order';
const EDIT_PRODUCT = 'Edit product';
const REMOVE_PRODUCT = 'Remove product';
const ADD_PRODUCT = 'Add product';
const SELECT_PRODUCT = 'Select product';
const SEE_MORE_PRODUCTS = 'See more products';
const RESUME_SUBSCRIPTION = 'Resume subscription';
const MERGE_SUBSCRIPTIONS = 'Merge Subscriptions';
const VIEW_SUBSCRIPTION_DETAILS = 'View Subscription Details';
const ADD_NEW_PRODUCT = 'Add new product';
const START_SUBSCRIPTION = 'Start Subscription';
const LOGOUT = 'Logout';
const VIEW_PAST_ORDERS = 'View past orders';
const VIP_REWARDS = 'Your Because Loyalty Milestone';


// OTHER
const SEE_ALL = 'See all Subscriptions';
const PAYMENT_METHOD_UPDATE = 'Payment method update';
const PAYMENT_METHOD_CHANGE = 'Payment method change';

let purchaseOption = null;
let isRecommended = false;
let rescheduledDate = null; // To store the last value of the second span element
let cancelReason2 = '';

const drawerIdToTypeMap = {
    reschedule_order: 'loop-cp-drawer-id-reschedule-order',
    delay_subscription: 'loop-cp-drawer-id-delay-order',
    pause_subscription: 'loop-cp-drawer-id-pause-subscription-popup',
    cadence_change: 'loop-cp-drawer-id-frequency-edit',
    edit_product: 'loop-cp-drawer-id-edit-product-line',
    add_product: 'loop-cp-drawer-id-add-product',
    upsell_product: 'loop-cp-drawer-id-select-product-upsell',
    remove_product: 'loop-cp-drawer-id-edit-product-remove',
    skip_order: 'loop-cp-drawer-id-skip-order-popup',
    start_subscription: 'loop-cp-drawer-id-create-new-subscription-v2',

    //Cancel subscription flow
    cancel_subscription: 'loop-cp-drawer-id-cancel-subscription',
    cancel_subscription_reason: 'loop-cp-drawer-id-cancel-subscription-cancel-flow',
};

const ajs_user_traits = localStorage.getItem('ajs_user_traits');
const userTraits = JSON.parse(ajs_user_traits);

const getCustomerData = async () => {
    const customerData = {
        email: loopProps?.customer?.email || userTraits?.email || '',
        firstName: loopProps?.customer?.first_name || userTraits?.firstName || '',
        lastName: loopProps?.customer?.last_name || userTraits?.lastName || '',
        shopifyId: loopProps?.customer?.shopifyId || '',
    };

    return customerData;
};

// Utils

const isElementVisible = (id) => {
    const element = document.getElementById(id);
    return element && element.offsetWidth > 0 && element.offsetHeight > 0; // Checks if the element is in the DOM and has dimensions
};

const getSubscriptionItems = () => {
    const loopCardLines = document.querySelectorAll('.loop-card-line');
    const productsArray = [];

    loopCardLines.forEach((card) => {
        const productTitleElement = card.querySelector('.loop-text-p1');
        const productTitle = productTitleElement ? productTitleElement.textContent : '';

        const sizeElement = card.querySelector('.loop-text-p2');
        const productSize = sizeElement ? sizeElement.textContent : '';

        const quantityElement = card.querySelector('.badge');
        const productQuantity = quantityElement ? quantityElement.textContent : '';

        const priceElement = card.querySelector('.loop-line-card-price-wrapper');
        let productPrice = '';
        if (priceElement) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = priceElement.innerHTML;
            const spans = tempDiv.querySelectorAll('span');
            spans.forEach((span) => span.remove());
            productPrice = tempDiv.textContent.trim();
        }

        const productObject = {
            productTitle,
            ...(sizeElement && { productSize }),
            productPrice,
            quantity: productQuantity,
        };

        productsArray.push(productObject);
    });

    return productsArray;
};

const getSubscriptionValue = () => {
    const loopTextElement = document.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong');

    if (loopTextElement) {
        const textContent = loopTextElement.textContent;
        const numbers = textContent.match(/[\d.]+/g).map(Number);
        const total = numbers.reduce((acc, num) => acc + num, 0);
        const roundedTotal = total.toFixed(2);

        return roundedTotal;
    }
};

function getCheckedRadioValue() {
    const radioInputs = document.querySelectorAll('.loop-drawer-body .loop-form-choice-input[type="radio"]');

    for (const radio of radioInputs) {
        if (radio.checked) {
            return radio.value;
        }
    }
    return null;
}

async function triggerEvent(eventName, callback) {
    if (eventTracker[eventName]) {
        return;
    }

    eventTracker[eventName] = true;
    await callback();

    setTimeout(() => {
        eventTracker[eventName] = false;
    }, 1000);
}

const getDrawerElement = () => {
    const drawerElements = document.querySelectorAll('.loop-drawer');
    return drawerElements.length > 0 ? drawerElements[drawerElements.length - 1] : null;
};

const getNextSiblingOfDrawer = (element) => {
    const drawerElement = element || getDrawerElement();
    if (!drawerElement) {
        console.warn('No drawer element found');
        return null;
    }
    return drawerElement.nextElementSibling || drawerElement;
};

function formatDate(date) {
    // Months are zero-indexed in JavaScript, so add 1 and pad with 0 if needed.
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    // Pad day with 0 if needed.
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
}

function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}


// End Utils

// MODAL MUTATION OBSERVER
// This observer is used to detect changes in the modal body.
// When a modal is opened, it will fire an event and the modal type will be determined.
// The event listener for the modal close button will also be added here.

const addModalCloseEventListeners = (modalElement) => {
    const modalCloseIcon = modalElement.querySelector('.loop-modal-header button');
    const modalCloseButton = Array.from(modalElement.querySelectorAll('.loop-modal-footer > div button')).find(
        (button) => button.textContent.trim() === 'Close'
    );

    if (modalCloseIcon) {
        modalCloseIcon.addEventListener('click', (event) => {
            // reconnectObserver();
        });
    }
    if (modalCloseButton) {
        modalCloseButton.addEventListener('click', (event) => {
            // reconnectObserver();
        });
    }
};
let modalObserver;
let isModalOpen = false;

function initModalObserver() {
    if (modalObserver) {
        modalObserver.disconnect();
    }
    modalObserver = new MutationObserver((mutationsList, observer) => {
        const modalBody = document.querySelector('.loop-modal');
        if (modalBody && !isModalOpen) {
            addModalEventListener(modalBody);
            isModalOpen = true;
        }
        if (!modalBody && isModalOpen) {
            isModalOpen = false;
        }
    });

    modalObserver.observe(document.body, { childList: true, subtree: true });
}

const addModalEventListener = (modalElement) => {
    addModalCloseEventListeners(modalElement);
    const modalType = modalElement.querySelector('.loop-modal-header .loop-h2')?.textContent;
    const modalConfirmButton = Array.from(
        modalElement.querySelector('.loop-modal-content').querySelectorAll('.loop-modal-footer > div button')
    ).find((button) => button.textContent.trim() === 'Confirm');
    if (modalConfirmButton) {
        modalConfirmButton.addEventListener('click', (event) => {
            switch (modalType) {
                case 'Skip order':
                    skipOrderEvent();
                    break;
                case 'Place an Immediate Order':
                    placeImmediateOrderEvent();
                    break;
                case 'Ship now':
                    shipNowEvent();
                    break;
                case 'Resume subscription':
                    resumeSubscriptionEvent();
                    break;
                case 'Reactivate subscription':
                    reactivateSubscriptionEvent();
                    break;
                case 'Logout':
                    logoutEvent();
                    break;
                default:
                    break;
            }
        });
    }
};

initModalObserver();
// Modal observer logic ends here

// DRAWER MUTATION OBSERVER
// This observer is used to detect changes in the drawer body.
// When a drawer is opened, it will fire an event and the drawer type will be determined.
// The event listener for the drawer close button will also be added here.

const addDrawerCloseEventListeners = (modalElement) => {
    const modalCloseIcon = modalElement.querySelector('.loop-modal-header button');
    const modalCloseButton = Array.from(modalElement.querySelectorAll('.loop-modal-footer > div button')).find(
        (button) => button.textContent.trim() === 'Close'
    );
};

let drawerObserver;
let isDrawerOpen = false;
function initDrawerObserverFinal() {
    drawerObserver = new MutationObserver(() => {
        const drawerData = getDrawerData();
        const drawerBody = getDrawerElement();

        if (drawerBody) {
            addDrawerEventListener(drawerBody);
            isDrawerOpen = true;
        }

        if (!drawerBody && isDrawerOpen) {
            isDrawerOpen = false;
            cancelReason2 = '';
            resetDrawerData();
        }

        if (drawerBody?.id === drawerIdToTypeMap.cancel_subscription && drawerData.hideCancelReasonInput) {
            document.querySelector('.loop_cp_cancel_subscription_remarks_text').style.display = 'none'; // Hide remarks text
            document.querySelectorAll('.loop-drawer-footer button').forEach((button) => (button.style.display = 'none')); // Disable all buttons
        }
    });
    drawerObserver.observe(document.body, { childList: true, subtree: true });
}

const getRelevantId = (element) => {
    const nextSibling = element.nextElementSibling;
    return nextSibling && nextSibling.id ? nextSibling.id : element.id;
};

const addDrawerEventListener = (drawer) => {
    addDrawerCloseEventListeners(drawer);
    const drawerType = drawer.id;
    const buttonElements = document.querySelectorAll('.loop-drawer-footer button');

    // if ([drawerIdToTypeMap.add_product, drawerIdToTypeMap.edit_product].includes(drawerType)) {
    //     buttonElements = Array.from(drawer.querySelector('.loop-drawer-content').querySelectorAll('.loop-drawer-footer > div button')).find(button => button.textContent.trim() === 'Close');
    //     // buttonElements = drawerElement.querySelector('.loop-drawer-content .loop-drawer-footer > div button:first-child');
    // } else {
    //     // buttonElements = Array.from(drawer.querySelector('.loop-drawer-content').querySelectorAll('.loop-drawer-footer > div button')).find(button => button.textContent.trim() === 'Close');
    //     buttonElements = drawer.querySelector('.loop-drawer-content .loop-drawer-footer > div button:last-child');

    // }
    getRescheduledDate();

    if (buttonElements.length) {
        buttonElements.forEach((button) => {
            button.addEventListener('click', (event) => {
                const closeButton = event.target.closest('.loop-drawer-footer').querySelector('button:last-child');
                const confirmBtn = event.target.closest('.loop-drawer-footer').querySelector('button:first-child');
                // const skipCompleteOrderButton = event.target.closest('.loop-btn.loop-btn-outline.loop-btn-size-lg.m-2').textContent.trim() == 'Skip complete order'

                if (event.target === closeButton) {
                    return;
                }
                if (confirmBtn) {

                    switch (drawerType) {
                        case drawerIdToTypeMap.reschedule_order:
                            getRescheduledDate();
                            triggerEvent('reschedule_order', rescheduleOrderEvent);
                            break;
                        case drawerIdToTypeMap.delay_subscription:
                            triggerEvent('delay_subscription', delayOrderEvent);
                            break;
                        case drawerIdToTypeMap.pause_subscription:
                            triggerEvent('pause_subscription', pauseSubscriptionEvent);
                            break;
                        case drawerIdToTypeMap.cadence_change:
                            triggerEvent('cadence_change', cadenceChangeEvent);
                            break;
                        case drawerIdToTypeMap.edit_product:
                            triggerEvent('edit_product', editProductEvent);
                            break;
                        case drawerIdToTypeMap.add_product:
                            triggerEvent('add_product', addProductEvent);
                            break;
                        case drawerIdToTypeMap.skip_order:
                            triggerEvent('skip_order', skipOrderEvent);
                            break;
                        case drawerIdToTypeMap.cancel_subscription_reason:
                            triggerEvent('cancel_subscription_reason', cancelSubscriptionReasonEvent);
                            break;
                        case drawerIdToTypeMap.cancel_subscription:
                            triggerEvent('cancel_subscription', cancelSubscriptionEvent);
                            break;
                        case drawerIdToTypeMap.remove_product:
                            triggerEvent('remove_product', removeProductEvent);
                            break;
                        case drawerIdToTypeMap.start_subscription:
                            triggerEvent('start_subscription', startSubscriptionEvent);
                            break;
                        default:
                            break;
                    }
                }
                triggerEvent('cta_click', () => drawerFooterButtonClickEvent(event.target));
            });
        });
    }
};

initDrawerObserverFinal();
// Drawer observer logic ends here

function getRescheduledDate() {
    const selectedButton = document.querySelector('.rdp-day[aria-pressed="true"]');
    if (selectedButton) {
        const day = selectedButton.querySelector('span').textContent;
        const monthYear = document.querySelector('.rdp-caption_label').textContent.split(' ');
        const [month, year] = monthYear;
        const monthNum = new Date(`${month} 1, 2000`).getMonth() + 1;
        rescheduledDate = `${monthNum}-${day}-${year}`;
    }
    return rescheduledDate;
}

const rescheduleOrderEvent = async () => {
    const loopCustomerData = await getCustomerData();

    const subscriptionStatusElement =
        window.loopProps.subscription.active || document.querySelector('.loop-label-subscription-active');
    const subscriptionStatus = subscriptionStatusElement ? subscriptionStatusElement.textContent : '';
    const nextOrderDateValue = document.getElementById('loop-next-order-card-date-value')?.textContent;

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        subscription_status: subscriptionStatus,
        subscription_products: getSubscriptionItems(),
        subscription_value: document.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong')
            .textContent,
        date_moved_from: new Date(nextOrderDateValue).toISOString().split('T')[0],
        date_moved_to: rescheduledDate || '',
        url: window.location.href,
        type: 'event',
        ...loopCustomerData,
    };

    Shopify.analytics.publish('reschedule_order_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });
};

async function skipOrderEvent() {
    const loopCustomerData = await getCustomerData();

    const subscriptionStatusElement =
        window.loopProps.subscription.active || document.querySelector('.loop-label-subscription-active');
    const subscriptionStatus = subscriptionStatusElement ? subscriptionStatusElement.textContent : '';

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        subscription_status: subscriptionStatus,
        subscription_products: getSubscriptionItems(),
        subscription_value:
            document?.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong')?.textContent || '',
        url: window.location.href,
        type: 'event',
        ...loopCustomerData,
    };

    Shopify.analytics.publish('skip_order_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });
}

async function placeImmediateOrderEvent() {
    const loopCustomerData = await getCustomerData();

    const subscriptionStatusElement =
        window.loopProps.subscription.active || document.querySelector('.loop-label-subscription-active');
    const subscriptionStatus = subscriptionStatusElement ? subscriptionStatusElement.textContent : '';

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        subscription_status: subscriptionStatus,
        subscription_products: getSubscriptionItems(),
        subscription_value:
            document?.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong')?.textContent || '',
        ...loopCustomerData,
    };

    Shopify.analytics.publish('place_immediate_order_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });
}

async function shipNowEvent() {
    const loopCustomerData = await getCustomerData();

    const subscriptionStatusElement =
        window.loopProps.subscription.active || document.querySelector('.loop-label-subscription-active');
    const subscriptionStatus = subscriptionStatusElement ? subscriptionStatusElement.textContent : '';

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        subscription_status: subscriptionStatus,
        subscription_products: getSubscriptionItems(),
        subscription_value:
            document?.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong')?.textContent || '',
        ...loopCustomerData,
    };

    ctaClickEvent({ text: "Ship Now", type: "Next Order" });


    Shopify.analytics.publish('ship_now_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });

}

async function delayOrderEvent() {
    const loopCustomerData = await getCustomerData();

    const subscriptionStatusElement =
        window.loopProps.subscription.active || document.querySelector('.loop-label-subscription-active');
    const subscriptionStatus = subscriptionStatusElement ? subscriptionStatusElement.textContent : '';

    const dateText = document.getElementById("loop-next-order-card-date-value").innerText;
    const date = new Date(dateText);
    const daysToAdd = Number(getCheckedRadioValue());

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        subscription_status: subscriptionStatus,
        subscription_products: getSubscriptionItems(),
        subscription_value:
            document?.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong')?.textContent || '',
        delay_count: daysToAdd,
        delay_interval: 'days',
        next_order_date: formatDate(addDays(date, daysToAdd)),
        ...loopCustomerData,
    };

    Shopify.analytics.publish('delay_order_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });
}

const getPausedInfo = () => {
    const pausedData = {};
    const nextOrderDate =
        document.querySelector('#loop-cp-drawer-id-pause-subscription-popup .loop-h3 strong')?.textContent || '';
    pausedData.nextOrderDate = nextOrderDate || '';
    const checkedRadio = document.querySelector('input[type="radio"]:checked');
    const label = checkedRadio ? document.querySelector(`label[for="${checkedRadio.id}"]`) : null;
    if (label) {
        const labelText = label.textContent.trim();
        const labelParts = labelText.split(' ');

        pausedData.pauseDurationCount = labelParts[0];
        pausedData.pauseDurationInterval = labelParts[1];
    }
    return pausedData;
};

let pauseEventFired = false;

const pauseSubscriptionEvent = async () => {
    const loopCustomerData = await getCustomerData();
    const subscriptionStatusElement = document.querySelector('.loop-label-subscription-active');
    const subscriptionStatus = subscriptionStatusElement ? subscriptionStatusElement.textContent : '';

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        subscription_status: subscriptionStatus,
        subscription_products: getSubscriptionItems(),
        subscription_value: document.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong')
            .textContent,
        url: window.location.href,
        type: 'event',
        ...getPausedInfo(),
        ...loopCustomerData,
    };

    Shopify.analytics.publish('subscription_paused_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });
};

const resumeSubscriptionEvent = async () => {
    const loopCustomerData = await getCustomerData();

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        ...loopCustomerData,
    };

    Shopify.analytics.publish('subscription_resumed_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });
};


// Helper function to map cadence label text to days
function getDaysFromCadence(cadenceText) {
    const text = cadenceText.toLowerCase();
    if (text.includes('15 days')) return 15;
    if (text.includes('1 month')) return 30;
    if (text.includes('2 months')) return 60;
    if (text.includes('3 months')) return 90;
    return null;
}

const cadenceChangeEvent = async () => {
    // Get the checked radio value
    const checkedValue = getCheckedRadioValue();
    if (!checkedValue) {
        return;
    }

    // Retrieve the corresponding label and its text
    const label = document.querySelector(`label[for="${checkedValue}"]`);
    const newCadence = label ? label.textContent : '';

    // Get the mapped days value from the label text
    const dateText = document.getElementById("loop-next-order-card-date-value").innerText;
    const date = new Date(dateText);
    const daysToAdd = getDaysFromCadence(newCadence);

    const loopCustomerData = await getCustomerData();
    const subscriptionShopifyId = document.getElementById('contract-shopify-id').textContent.substring(1) || '';

    // Prepare event data with additional days property if needed
    const eventData = {
        subscription_shopify_id: subscriptionShopifyId,
        subscription_products: getSubscriptionItems(),
        subscription_value: document.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong')
            .textContent,
        old_cadence: document.querySelector('#loop-subscription-plan-card-content-wrapper > div').textContent,
        new_cadence: newCadence,
        days_to_add: daysToAdd,
        next_order_date: formatDate(addDays(date, daysToAdd)),
        url: window.location.href,
        type: 'event',
        ...loopCustomerData,
    };

    Shopify.analytics.publish('cadence_change_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });
};


const editProductEvent = async () => {
    const loopCustomerData = await getCustomerData();
    const drawerData = getDrawerData();

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        subscription_products: getSubscriptionItems(),
        subscription_value: document.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong')
            .textContent,
        url: window.location.href,
        type: 'event',
        name: drawerData.content.title,
        price: drawerData.content.price,
        oldPrice: drawerData.content.oldPrice,
        quantity: drawerData.content.quantity,
        packSize: drawerData.content.packSize,
        value: `$${(Number(drawerData.content.price) * Number(drawerData.content.quantity)).toFixed(2)}`,
        ...loopCustomerData,
    };

    Shopify.analytics.publish('edit_product_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });
};

const addProductEvent = async () => {
    const loopCustomerData = await getCustomerData();
    const drawerData = getDrawerData();
    let eventName = 'Add new subscription';
    let subEventName = '';

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        subscription_products: getSubscriptionItems(),
        subscription_value: document.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong')
            .textContent,
        name: drawerData.content.title,
        price: drawerData.content.price,
        oldPrice: drawerData.content.oldPrice,
        quantity: drawerData.content.quantity,
        packSize: drawerData.content.packSize,
        purchaseOption: drawerData.content.purchaseOption,
        value: `$${(Number(drawerData.content.price) * Number(drawerData.content.quantity)).toFixed(2)}`,
        url: window.location.href,
        type: 'event',
        isSubscription: drawerData.content.purchaseOption === 'subscription',
        ...loopCustomerData,
    };

    Shopify.analytics.publish('product_added_to_subscription_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });

    // CTA CLICK EVENT

    if (drawerData.content.purchaseOption) {
        if (drawerData.content.purchaseOption === 'onetime') {
            subEventName = `One Time${drawerData.isRecommended ? ' - Recommended' : ''}`;
        } else if (drawerData.content.purchaseOption === 'subscription') {
            subEventName = `Subscription${drawerData.isRecommended ? ' - Recommended' : ''}`;
        }
    }

    const data = {
        text: `${eventName}${subEventName ? ` - ${subEventName}` : ''}`,
    };

    ctaClickEvent(data);
};

const removeProductEvent = async () => {
    const drawerData = getDrawerData();
    const loopCustomerData = await getCustomerData();
    const subscriptionStatusElement = document.querySelector('.loop-label-subscription-active');
    const subscriptionStatus = subscriptionStatusElement ? subscriptionStatusElement.textContent : '';

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        subscription_status: subscriptionStatus,
        subscription_products: getSubscriptionItems(),
        subscription_value: document.querySelector('#loop-cp-subscription-detail-overview-header .loop-text-p1 strong').textContent,
        url: window.location.href,
        type: 'event',
        name: drawerData.content.title,
        price: drawerData.content.price,
        oldPrice: drawerData.content.oldPrice,
        quantity: drawerData.content.quantity,
        packSize: drawerData.content.packSize,
        value: `$${(Number(drawerData.content.price) * Number(drawerData.content.quantity)).toFixed(2)}`,
        ...loopCustomerData,
    };

    // Shopify.analytics.publish('subscription_paused_event', {
    //     ...eventData,
    //     userId: window?.loopProps?.customer.shopifyId || '',
    // })
};


const reactivateSubscriptionEvent = async () => {
    const loopCustomerData = await getCustomerData();

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        subscription_products: getSubscriptionItems(),
        first_name: loopCustomerData.firstName,
        last_name: loopCustomerData.lastName,
        email: loopCustomerData.email,
        user_id: window?.loopProps?.customer.shopifyId || '',
        type: 'event'
    };

    Shopify.analytics.publish('reactivate_subscription_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });
};


const redeemCouponCodeEvent = async () => {
    const loopCustomerData = await getCustomerData();
    const pointsButton = document.querySelector('#loop-loyalty-points-slider-card .loop-btn.loop-btn-outline');
    const buttonText = pointsButton ? pointsButton.textContent : '';

    // Parse points and price from text like "434 points = $43.40"
    const points = buttonText.match(/(\d+) points/)?.[1] || '';
    const price = buttonText.match(/\$(\d+\.\d+)/)?.[1] || '';

    Shopify.analytics.publish('redeem_coupon_code_event', {
        points,
        price: `$${price}`,
        ...loopCustomerData,
    });
}

const cancelSubscriptionReasonEvent = async () => {
    const radioTextValue = 'I already have too much at home';
    let skippedNextOrder = false;

    const radio = getCheckedRadioValue();
    const label = document.querySelector(`#loop-cp-drawer-id-cancel-subscription-cancel-flow label[for="${radio}"]`);
    const selectedCancelReason = label ? label.textContent : '';
    cancelReason2 = selectedCancelReason;

    if (selectedCancelReason === radioTextValue) {
        setDrawerData({
            hideCancelReasonInput: true,
        });
        if (!skippedNextOrder) {
            const subscriptionId = window.loopProps.subscription.id;
            // Same-origin App Proxy: Shopify signs it for the logged-in customer.
            fetch(`/apps/cove/subscriptions/${subscriptionId}/skip-next`, { method: 'POST' });
            skippedNextOrder = true;
        }
    }
};

const cancelSubscriptionEvent = async () => {
    const loopCustomerData = await getCustomerData();
    const cancel_reason_remarks = document.querySelector('.loop_cp_cancel_subscription_remarks_text')?.value || '';

    const eventData = {
        subscription_shopify_id: window?.loopProps?.subscription?.shopifyId || '',
        url: window.location.href,
        cancel_reason: cancelReason2,
        cancel_reason_input: cancel_reason_remarks,
        type: 'event',
        ...loopCustomerData,
    };
    Shopify.analytics.publish('cancel_subscription_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });

};

async function ctaClickEvent(data) {
    const loopCustomerData = await getCustomerData();
    const { text, type, destination } = data;

    const isSubscriptionPage = window.location.pathname.includes('/subscription/');
    const fulltype = isSubscriptionPage ? `Subscription page ${type ? `- ${type}` : ''}` : 'Main page';
    const eventData = {
        destination: destination || '',
        type: fulltype,
        text: text || 'Unknown CTA Click',
        url: window.location.href,
        email: loopCustomerData.email || '',
    };


    Shopify.analytics.publish('clicked_event', {
        ...eventData,
        userId: window?.loopProps?.customer.shopifyId || '',
    });
}

// ALL CTA CLICK EVENTS //

document.body.addEventListener('click', async (e) => {
    // Upsell Card Click Event
    const upsellCard = e.target.closest('.loop-card.loop-card-upsell');
    if (upsellCard) {
        await upsellCardClickEvent();
    }

    // Payment Method Update Button Click Event
    const paymentMethodUpdateButton = e.target.closest('#loop-cp-payment-method-update-btn');
    if (paymentMethodUpdateButton) {
        await paymentMethodUpdateButtonClickEvent();
    }

    // Payment Method Change Button Click Event
    const paymentMethodChangeButton = e.target.closest('#loop-cp-payment-method-change-btn');
    if (paymentMethodChangeButton) {
        await paymentMethodChangeButtonClickEvent();
    }

    // Pause Subscription Button Click Event
    const pauseSubscriptionButton = e.target.closest('#loop-pause-btn');
    if (pauseSubscriptionButton) {
        await pauseSubscriptionButtonClickEvent();
    }

    // Cadence Change Button Click Event
    const cadenceChangeButton = e.target.closest('#loop-subscription-plan-edit-btn');
    if (cadenceChangeButton) {
        await cadenceChangeButtonClickEvent();
    }

    // Upsell View More Button Click Event
    const upsellViewMoreButton = e.target.closest('#loop-cp-upsell-view-more-btn');
    if (upsellViewMoreButton) {
        await upsellViewMoreButtonClickEvent();
    }

    // Back Button Click Event
    const backButton = e.target.closest('#loop-all-subscription-list-back-button');
    if (backButton) {
        await backButtonClickEvent();
    }

    // Cancel Subscription Button Click Event
    const cancelSubscriptionButton = e.target.closest('#loop-cancel-btn');
    if (cancelSubscriptionButton) {
        await cancelSubscriptionButtonClickEvent();
    }

    const loopLoyaltyButton = e.target.closest('#loop-loyalty-btn');
    if (loopLoyaltyButton) {
        await loopLoyaltyButtonClickEvent();
    }

    const loopRedeemPointsButton = e.target.closest('.loop-card.loop-pointer')?.querySelector('.loop-h3')?.textContent === 'Redeem your points';
    if (loopRedeemPointsButton) {
        await loopRedeemPointsButtonClickEvent();
    }

    const getCouponCodeButton = e.target.closest('#loop-loyalty-points-slider-button')
    if (getCouponCodeButton) {
        await getCouponCodeButtonClickEvent();
    }

    const mergeButton = e.target.closest('#loop-listing-merge-btn');
    if (mergeButton) {
        await mergeButtonClickEvent();
    }

    const viewDetailsButton = e.target.closest('.loop-cp-subscription-list-active-contracts-container .loop-card');
    if (viewDetailsButton) {
        await viewDetailsButtonClickEvent();
    }

    const addNewSubscriptionButton = e.target.closest('.loop-btn.loop-btn-primary.loop-btn-size-lg');
    if (addNewSubscriptionButton && addNewSubscriptionButton.textContent.trim() === 'Add new subscription') {
        await addNewSubscriptionButtonClickEvent();
    }

    const viewPastOrdersButton = e.target.closest('#loop-history-drawer-btn');
    if (viewPastOrdersButton) {
        await viewPastOrdersButtonClickEvent();
    }

    const vipRewardsLink = e.target.closest("a[href^='https://qa2.becausemarket.com/apps/bubblehouse/rewards/']");
    if (vipRewardsLink) {
        await vipRewardsLinkClickEvent();
    }

    const shippingAddressEditButton = e.target.closest('#loop-shipping-address-edit-btn');
    if (shippingAddressEditButton) {
        await shippingAddressEditButtonClickEvent();
    }

    const applyBtn = e.target.closest("#loop-discounts-apply-btn");
    const discountCodeInput = document.querySelector("#loop-discount-card-input-wrapper input");
    if (applyBtn && discountCodeInput?.value) {
        await applyBtnClickEvent();
    }

    const reactivateButton = e.target.closest('.loop-btn.loop-btn-primary');
    const reactivateButtonById = e.target.closest('#loop-reactivate-btn');
    if (reactivateButtonById ||(reactivateButton && reactivateButton.textContent.trim().includes('Reactivate'))) {
        await reactivateSubscriptionClickEvent();
    }

    // const drawerFooterRemoveButton = e.target.closest('.loop-drawer-footer .loop-remove-button');
    // if (drawerFooterRemoveButton) {
    //     await removeProductEventButtonClickEvent();
    // }
});

async function reactivateSubscriptionClickEvent() {
    ctaClickEvent({ text: 'Reactivate', type: 'Subscription' });
}

async function upsellCardClickEvent() {
    setDrawerData({ isRecommended: true });
    ctaClickEvent({ text: 'Edit', type: 'Product card' });
}

async function paymentMethodUpdateButtonClickEvent() {
    ctaClickEvent({ text: "Update", type: "Payment Details" });
}

async function paymentMethodChangeButtonClickEvent() {
    ctaClickEvent({ text: "Change", type: "Payment Details" });
}

async function pauseSubscriptionButtonClickEvent() {
    ctaClickEvent({ text: PAUSE_SUBSCRIPTION });
}

async function cadenceChangeButtonClickEvent() {
    ctaClickEvent({ text: 'Edit', type: 'Delivery Frequency' });
}

async function shippingAddressEditButtonClickEvent() {
    ctaClickEvent({ text: 'Edit', type: 'Shipping Address' });
}

async function applyBtnClickEvent() {
    ctaClickEvent({ text: 'Apply', type: 'Discount Code' });
}


async function upsellViewMoreButtonClickEvent() {
    ctaClickEvent({ text: SEE_MORE_PRODUCTS, type: 'Product Recommended' });
}

async function backButtonClickEvent() {
    ctaClickEvent({ text: SEE_ALL });
}

async function cancelSubscriptionButtonClickEvent() {
    ctaClickEvent({ text: CANCEL_SUBSCRIPTION });
}

async function loopLoyaltyButtonClickEvent() {
    ctaClickEvent({ text: LOOP_LOYALTY });
}

async function loopRedeemPointsButtonClickEvent() {
    ctaClickEvent({ text: LOOP_REDEEM_POINTS });
}

async function getCouponCodeButtonClickEvent() {

    await redeemCouponCodeEvent();
    ctaClickEvent({
        text: GET_COUPON_CODE,
    });
}

async function mergeButtonClickEvent() {
    ctaClickEvent({ text: MERGE_SUBSCRIPTIONS });
}

async function viewDetailsButtonClickEvent() {
    ctaClickEvent({ text: VIEW_SUBSCRIPTION_DETAILS });
}

async function addNewSubscriptionButtonClickEvent() {
    ctaClickEvent({ text: ADD_NEW_PRODUCT });
}

async function startSubscriptionEvent() {
    ctaClickEvent({ text: START_SUBSCRIPTION });
}

async function logoutEvent() {
    ctaClickEvent({ text: LOGOUT });
}

async function viewPastOrdersButtonClickEvent() {
    ctaClickEvent({ text: VIEW_PAST_ORDERS });
}

async function vipRewardsLinkClickEvent() {
    ctaClickEvent({ text: VIP_REWARDS });
}

async function drawerFooterButtonClickEvent(button) {
    const buttonActions = {
        'Update Product': 'loop-update-button',
        'Change Product': 'loop-swap-button',
        'Remove Product': 'loop-remove-button',
    };

    for (const [text, className] of Object.entries(buttonActions)) {
        if (button.classList.contains(className)) {
            ctaClickEvent({ text });
            return;
        }
    }
}
